import React from 'react';

function OpenAccount() {
    return (  
        <div className='container my-5'>
                <div className='row text-center'>
                    
                    <h1 className='mt-5'>Open a Zerodha account</h1>
                    <p className='mt-3'style={{opacity:"70%"}}>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades.</p>
                    <button className=' mt-3 p-3 btn btn-primary' style={{width: "30%" ,margin: "0 auto"}}>Signup Now for free</button>
                </div>
        </div>
    );
}

export default OpenAccount;